import { useEffect, useRef } from 'react';

import { AnalyticsBrowser } from '@segment/analytics-next';

import { getMobileAppInfo } from 'helpers';

export type AnalyticsPlatform = 'web' | 'ios' | 'android' | 'mobile_app';

export type PlatformProperties = {
  platform: AnalyticsPlatform;
  app_version?: string;
  app_build?: string;
};

export const getPlatformProperties = (): PlatformProperties => {
  const app = getMobileAppInfo();

  if (!app) return { platform: 'web' };

  return {
    platform: app.platform,
    ...(app.version && { app_version: app.version }),
    ...(app.build && { app_build: app.build }),
  };
};

// Segment can't remove a middleware, so register once per browser instance.
export const usePlatformProperties = (
  analyticsBrowser: AnalyticsBrowser | null,
) => {
  const registeredBrowserRef = useRef<AnalyticsBrowser | null>(null);

  useEffect(() => {
    if (!analyticsBrowser) return;
    if (registeredBrowserRef.current === analyticsBrowser) return;
    registeredBrowserRef.current = analyticsBrowser;

    analyticsBrowser.addSourceMiddleware(({ payload, next }) => {
      try {
        payload.obj.properties = {
          ...payload.obj.properties,
          ...getPlatformProperties(),
        };
      } catch (error) {
        console.error('[Analytics] platform middleware error', error);
      } finally {
        next(payload);
      }
    });
  }, [analyticsBrowser]);
};
